import { render, staticRenderFns } from "./RoutePlansShow.vue?vue&type=template&id=5a684430&"
import script from "./RoutePlansShow.vue?vue&type=script&lang=js&"
export * from "./RoutePlansShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports